import { RefObject, useEffect } from 'react';
import { intersects } from '@utils';

export const useIntersects = (callback: (index: number) => void, menRef: RefObject<HTMLDivElement>, items: any[]) => {
  useEffect(() => {
    if (items.length > 0) {
      const id = setInterval(() => {
        let success = false;

        for (let i = 0; i < items.length; i++) {
          const item = items[i].ref.current;

          if (menRef.current && item) {
            success = intersects(menRef.current, item);

            if (success) {
              callback(i);
              break;
            }
          }
        }
      }, 10);

      return () => clearInterval(id);
    }
  }, [callback, items, menRef]);
}